import React, { useState } from 'react';


const WHATSAPP_NUMBERS = [
  { number: '263772758875', display: '+263 772 758 875', label: 'Sales & Enquiries' },
  { number: '263785661758', display: '+263 785 661 758', label: 'Support & Orders'  },
];

const Contact = () => {
  
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [showPicker, setShowPicker] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  // Build the WhatsApp message from form fields
  const buildMessage = () => {
    return (
      `Hello Techdave Solutions! 👋\n\n` +
      `*Name:* ${form.name}\n` +
      `${form.email  ? `*Email:* ${form.email}\n`  : ''}` +
      `${form.phone  ? `*Phone:* ${form.phone}\n`  : ''}` +
      `\n*Message:*\n${form.message}\n\n` +
      `_Sent via techdave website contact form_`
    );
  };

  // Validate then show number picker
  const handleSubmit = () => {
    if (!form.name.trim())    return setError('Please enter your name.');
    if (!form.message.trim()) return setError('Please enter a message.');
    setShowPicker(true);
  };

  // Open WhatsApp with chosen number
  const sendToWhatsApp = (number) => {
    const url = `https://wa.me/${number}?text=${encodeURIComponent(buildMessage())}`;
    window.open(url, '_blank');
    setShowPicker(false);
    setForm({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <main style={styles.main()}>
      <div style={styles.container}>

        {/* Header */}
        <div style={styles.header}>
          <span style={styles.pill}>Get in Touch</span>
          <h1 style={styles.title()}>Contact Techdave Solutions</h1>
          <p style={styles.sub}>Fill in the form and your message will be sent directly to our WhatsApp.</p>
        </div>

        <div style={styles.grid}>

          {/* ── Store Info ── */}
          <div style={styles.infoCol}>
            <div style={styles.infoCard()}>
              <h2 style={styles.infoTitle}>Store Information</h2>

              {[
                { icon: '📍', label: 'Location', value: 'B30 Eastgate Market, Harare, Zimbabwe' },
                { icon: '📞', label: 'Phone 1',  value: '+263 772 758 875', href: 'tel:+263772758875' },
                { icon: '📞', label: 'Phone 2',  value: '+263 785 661 758', href: 'tel:+263785661758' },
                { icon: '✉️', label: 'Sales Email', value: 'sales@techdavesolutions.co.zw', href: 'mailto:sales@techdavesolutions.co.zw' },
                { icon: '✉️', label: 'Info Email',  value: 'info@techdavesolutions.co.zw',  href: 'mailto:info@techdavesolutions.co.zw'  },
                { icon: '🕐', label: 'Hours',    value: 'Monday – Saturday: 8:00 AM – 5:00 PM' },
              ].map((item) => (
                <div key={item.label} style={styles.infoRow}>
                  <span style={styles.infoIcon}>{item.icon}</span>
                  <div>
                    <div style={styles.infoLabel}>{item.label}</div>
                    {item.href
                      ? <a href={item.href} style={styles.infoLink}>{item.value}</a>
                      : <div style={styles.infoValue}>{item.value}</div>
                    }
                  </div>
                </div>
              ))}

              <div style={styles.divider} />

              {/* WhatsApp quick links */}
              <div style={styles.waButtons}>
                {WHATSAPP_NUMBERS.map(n => (
                  <a
                    key={n.number}
                    href={`https://wa.me/${n.number}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.waBtn}
                  >
                    <span>💬</span>
                    <div>
                      <div style={styles.waBtnNum}>{n.display}</div>
                      <div style={styles.waBtnLabel}>{n.label}</div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* ── Contact Form ── */}
          <div style={styles.formCol}>
            <div style={styles.formCard()}>
              <div style={styles.formHeader}>
                <h2 style={styles.formTitle}>Send a Message</h2>
                <div style={styles.waBadge}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  <span>Sends via WhatsApp</span>
                </div>
              </div>

              {/* Form fields */}
              {[
                { name: 'name',    label: 'Full Name *',            placeholder: 'Your full name',          type: 'text'  },
                { name: 'email',   label: 'Email Address',          placeholder: 'your@email.com',          type: 'email' },
                { name: 'phone',   label: 'Phone Number',           placeholder: '+263 7XX XXX XXX',        type: 'tel'   },
              ].map(f => (
                <div key={f.name} style={styles.field}>
                  <label style={styles.label()}>{f.label}</label>
                  <input
                    type={f.type}
                    name={f.name}
                    value={form[f.name]}
                    onChange={handleChange}
                    placeholder={f.placeholder}
                    style={styles.input()}
                  />
                </div>
              ))}

              <div style={styles.field}>
                <label style={styles.label()}>Message *</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell us what you're looking for..."
                  style={{ ...styles.input(), minHeight: '140px', resize: 'vertical' }}
                />
              </div>

              {error && <div style={styles.errorMsg}>{error}</div>}

              {/* Preview of what will be sent */}
              {(form.name || form.message) && (
                <div style={styles.preview()}>
                  <div style={styles.previewTitle}>📱 Preview — what your team will receive:</div>
                  <div style={styles.previewText}>
                    {form.name    && <div><strong>Name:</strong> {form.name}</div>}
                    {form.email   && <div><strong>Email:</strong> {form.email}</div>}
                    {form.phone   && <div><strong>Phone:</strong> {form.phone}</div>}
                    {form.message && <div><strong>Message:</strong> {form.message}</div>}
                  </div>
                </div>
              )}

              <button onClick={handleSubmit} style={styles.submitBtn}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="white" style={{ flexShrink: 0 }}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Send Message via WhatsApp →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Number Picker Modal ── */}
      {showPicker && (
        <div style={styles.overlay} onClick={() => setShowPicker(false)}>
          <div style={styles.picker} onClick={e => e.stopPropagation()}>
            <div style={styles.pickerHeader}>
              <div style={styles.pickerIcon}>💬</div>
              <div>
                <div style={styles.pickerTitle}>Send to WhatsApp</div>
                <div style={styles.pickerSub}>Choose which number to send your message to</div>
              </div>
            </div>

            <div style={styles.pickerNumbers}>
              {WHATSAPP_NUMBERS.map(n => (
                <button
                  key={n.number}
                  onClick={() => sendToWhatsApp(n.number)}
                  style={styles.pickerBtn}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(37,211,102,0.1)'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = '#2a2a2a'}
                >
                  <div style={styles.pickerBtnIcon}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                  </div>
                  <div style={{ flex: 1, textAlign: 'left' }}>
                    <div style={styles.pickerNum}>{n.display}</div>
                    <div style={styles.pickerLabel}>{n.label}</div>
                  </div>
                  <span style={styles.pickerArrow}>›</span>
                </button>
              ))}
            </div>

            <button onClick={() => setShowPicker(false)} style={styles.pickerCancel}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }
      `}</style>
    </main>
  );
};

const styles = {
  main: () => ({
    minHeight: '100vh', paddingTop: '72px',
    backgroundColor: '#f5f5f5',
    color: '#1a1a1a',
  }),
  container: { maxWidth: '1100px', margin: '0 auto', padding: '60px 24px' },
  header: {
    textAlign: 'center', marginBottom: '56px',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px',
  },
  pill: {
    background: 'rgba(204,0,0,0.12)', border: '1px solid rgba(204,0,0,0.3)',
    color: '#CC0000', padding: '6px 16px', borderRadius: '100px',
    fontSize: '13px', fontWeight: '600',
  },
  title: () => ({
    fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: '900', letterSpacing: '-0.02em',
    color: '#1a1a1a',
  }),
  sub: { fontSize: '16px', color: 'rgba(128,128,128,0.9)' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: '32px', alignItems: 'start' },

  // ── Info card ──
  infoCol: {},
  infoCard: () => ({
    backgroundColor: '#ffffff',
    borderRadius: '16px', padding: '32px',
    border: '1px solid rgba(0,0,0,0.06)',
    display: 'flex', flexDirection: 'column', gap: '18px',
  }),
  infoTitle: { fontSize: '20px', fontWeight: '800', color: '#CC0000', paddingBottom: '12px', borderBottom: '1px solid rgba(204,0,0,0.2)' },
  infoRow:   { display: 'flex', alignItems: 'flex-start', gap: '14px' },
  infoIcon:  { fontSize: '20px', marginTop: '2px', minWidth: '24px' },
  infoLabel: { fontSize: '12px', fontWeight: '600', color: '#CC0000', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '2px' },
  infoValue: { fontSize: '15px', lineHeight: 1.5 },
  infoLink:  { fontSize: '15px', lineHeight: 1.5, color: '#CC0000', textDecoration: 'none', fontWeight: '600' },
  divider:   { height: '1px', backgroundColor: 'rgba(204,0,0,0.15)' },
  waButtons: { display: 'flex', flexDirection: 'column', gap: '10px' },
  waBtn: {
    display: 'flex', alignItems: 'center', gap: '12px',
    backgroundColor: '#25D366',
    border: 'none',
    borderRadius: '12px', padding: '14px 16px',
    textDecoration: 'none', transition: 'all 0.2s',
    boxShadow: '0 4px 16px rgba(37,211,102,0.35)',
  },
  waBtnNum:   { fontSize: '15px', fontWeight: '800', color: '#ffffff' },
  waBtnLabel: { fontSize: '12px', color: 'rgba(255,255,255,0.85)', marginTop: '1px' },

  // ── Form card ──
  formCol: {},
  formCard: () => ({
    backgroundColor: '#ffffff',
    borderRadius: '16px', padding: '36px',
    border: '1px solid rgba(0,0,0,0.06)',
    display: 'flex', flexDirection: 'column', gap: '18px',
  }),
  formHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' },
  formTitle:  { fontSize: '22px', fontWeight: '800', color: '#CC0000' },
  waBadge: {
    display: 'flex', alignItems: 'center', gap: '6px',
    backgroundColor: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.25)',
    borderRadius: '100px', padding: '4px 12px',
    fontSize: '12px', fontWeight: '600', color: '#25D366',
  },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: () => ({
    fontSize: '13px', fontWeight: '600',
    color: '#555',
  }),
  input: () => ({
    padding: '12px 16px', borderRadius: '10px',
    border: '1.5px solid rgba(0,0,0,0.12)',
    backgroundColor: '#f9f9f9',
    color: '#1a1a1a',
    fontSize: '15px', outline: 'none',
    transition: 'border-color 0.2s ease',
    fontFamily: 'inherit', width: '100%',
  }),
  errorMsg: {
    backgroundColor: 'rgba(204,0,0,0.08)', border: '1px solid rgba(204,0,0,0.25)',
    color: '#CC0000', padding: '10px 14px', borderRadius: '8px',
    fontSize: '14px', fontWeight: '600',
  },
  preview: () => ({
    backgroundColor: 'rgba(37,211,102,0.04)',
    border: '1px solid rgba(37,211,102,0.2)',
    borderRadius: '10px', padding: '14px 16px',
    display: 'flex', flexDirection: 'column', gap: '6px',
  }),
  previewTitle: { fontSize: '12px', fontWeight: '700', color: '#25D366', marginBottom: '4px' },
  previewText:  { fontSize: '13px', color: 'rgba(128,128,128,0.9)', lineHeight: 1.6, display: 'flex', flexDirection: 'column', gap: '4px' },
  submitBtn: {
    padding: '15px 20px', borderRadius: '12px', border: 'none',
    background: 'linear-gradient(135deg, #25D366, #128C7E)',
    color: '#ffffff', fontWeight: '800', fontSize: '16px', cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(37,211,102,0.35)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
    transition: 'all 0.2s ease',
  },

  // ── Number picker modal ──
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9999,
    backgroundColor: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
  },
  picker: {
    backgroundColor: '#1a1a1a', borderRadius: '20px',
    width: '100%', maxWidth: '360px',
    border: '1px solid rgba(37,211,102,0.3)',
    boxShadow: '0 24px 80px rgba(0,0,0,0.6)',
    overflow: 'hidden',
    animation: 'slideUp 0.25s ease',
  },
  pickerHeader: {
    display: 'flex', alignItems: 'center', gap: '14px',
    padding: '20px 20px 16px',
    background: 'linear-gradient(135deg, #25D366, #128C7E)',
  },
  pickerIcon: {
    width: '44px', height: '44px', borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '22px', flexShrink: 0,
  },
  pickerTitle: { fontSize: '17px', fontWeight: '800', color: '#fff' },
  pickerSub:   { fontSize: '12px', color: 'rgba(255,255,255,0.8)', marginTop: '2px' },
  pickerNumbers: { padding: '12px', display: 'flex', flexDirection: 'column', gap: '6px' },
  pickerBtn: {
    display: 'flex', alignItems: 'center', gap: '14px',
    padding: '14px 16px', borderRadius: '12px', border: 'none',
    backgroundColor: '#2a2a2a', cursor: 'pointer',
    transition: 'background 0.15s', width: '100%',
  },
  pickerBtnIcon: {
    width: '40px', height: '40px', borderRadius: '50%',
    backgroundColor: 'rgba(37,211,102,0.12)',
    border: '1px solid rgba(37,211,102,0.25)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
  pickerNum:    { fontSize: '15px', fontWeight: '700', color: '#fff' },
  pickerLabel:  { fontSize: '12px', color: 'rgba(255,255,255,0.45)', marginTop: '2px' },
  pickerArrow:  { fontSize: '22px', color: '#25D366', fontWeight: '700' },
  pickerCancel: {
    width: '100%', padding: '14px', border: 'none',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    backgroundColor: 'transparent', color: 'rgba(255,255,255,0.4)',
    fontWeight: '600', fontSize: '14px', cursor: 'pointer',
  },
};

export default Contact;
